<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M102.767 35.7681H36.6416V109.8H102.767V35.7681Z"
      fill="var(--jd-color-line-100)"
    />
    <path
      d="M81.0913 36.238H100.3L90.7998 86.8L81.0913 36.238Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M76.2816 98.9699C75.2047 99.8635 73.8494 100.353 72.4499 100.353H28.8C25.4863 100.353 22.8 97.6664 22.8 94.3527V27.4331C22.8 24.1194 25.4863 21.4331 28.8 21.4331H86.3784C89.6921 21.4331 92.3784 24.1194 92.3784 27.4331V82.7938C92.3784 84.5787 91.5837 86.271 90.2101 87.4109L76.2816 98.9699Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M65.9179 43.039C65.9179 37.7322 61.2007 33.4572 55.7464 34.1943C51.2504 34.7839 48.0073 38.8378 48.0073 43.4075V48.1984M52.8719 47.9773V42.9653C52.8719 40.9752 54.1986 39.1326 56.115 38.764C57.7365 38.4692 59.2106 39.0589 60.1688 40.2382"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M91 83.4741H79.1849C75.4259 83.4741 73.5833 85.5379 73.5833 88.0439V99.8368"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M66.4833 44.8H47.1168C45.285 44.8 43.8 46.285 43.8 48.1168V60.4833C43.8 62.3151 45.285 63.8 47.1168 63.8H66.4833C68.3151 63.8 69.8 62.3151 69.8 60.4833V48.1168C69.8 46.285 68.3151 44.8 66.4833 44.8Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M59.6968 51.748C59.6968 50.1265 58.3701 48.7998 56.7485 48.7998C55.127 48.7998 53.8003 50.1265 53.8003 51.748C53.8003 52.7799 54.3162 53.7381 55.2007 54.254L54.6848 59.2979H58.9597L58.4438 54.254C59.1808 53.7381 59.6968 52.7799 59.6968 51.748Z"
      fill="var(--jd-color-surface-400)"
    />
    <path
      d="M80.0277 72.3857H32.561V76.9555H80.0277V72.3857Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M61.0852 80.2722H32.561V84.842H61.0852V80.2722Z"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M108.418 19.4974C108.934 20.5293 108.566 21.7823 107.534 22.2982L102.595 24.8042C101.563 25.3202 100.31 24.9516 99.7945 23.9198C99.2786 22.8879 99.6471 21.6349 100.679 21.1189L105.617 18.6129C106.649 18.097 107.902 18.5392 108.418 19.4974Z"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M98.0255 10.7998L94.7825 16.6963"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'PermissionEmpty',
  setup() {
    const ns = useNamespace('empty')
    return {
      ns,
      id: ++id,
    }
  },
})
</script>
